module.exports = __webpack_public_path__ + "static/media/kkbacground.27f0c26b.png";